import { fetcher } from "@/services/api/fetcher";
import { useQuery } from "@tanstack/react-query";
import { DetailFarmerGroupResponse, FarmerGroupResponse } from "./interface";

//SECTION - Get All Farmer Groups
const getPoktan = async (
  query?: string
): Promise<ApiResponse<DataPaginate<FarmerGroupResponse>>> => {
  return await fetcher(query ? `master/poktan?${query}` : `master/poktan`);
};

export const useGetPoktan = (query?: string) => {
  return useQuery<ApiResponse<DataPaginate<FarmerGroupResponse>>, Error>({
    queryKey: ["useGetPoktan", query],
    queryFn: () => getPoktan(query),
    keepPreviousData: true,
    refetchIntervalInBackground: true,
  });
};

const getPoktanById = async (
  id: string
): Promise<ApiResponse<DataObject<DetailFarmerGroupResponse>>> => {
  return await fetcher(`master/poktan/${id}`);
};

export const useGetPoktanById = (id: string) => {
  return useQuery<ApiResponse<DataObject<DetailFarmerGroupResponse>>, Error>({
    queryKey: ["useGetPoktanById", id],
    queryFn: () => getPoktanById(id),
    keepPreviousData: true,
    refetchIntervalInBackground: true,
    enabled: !!id,
  });
};
